import React from "react";

const SmartEngineering = () => {
  return (
    <section className="z-50 relative" id="smart_engineering">
      <div className="relative z-30 flex h-screen justify-center items-center bg-black overflow-hidden py-12 px-6 md:py-20">
        <video
          id="videoMachine"
          width="100%"
          autoPlay
          loop
          muted
          playsInline
          className="absolute z-0 w-full scale-[3.6] md:scale-[2] lg:scale-150"
          style={
            {
              // filter: "blur(1px)",
              // objectFit: "cover",
              // transform: "scale(1.06)",
            }
          }
        >
          <source
            src="https://cdn.pmlsound.com/anthem/avm90/videos/smart_engineering.mp4"
            type="video/mp4"
          />
        </video>

        <div className="relative w-full h-screen  max-w-5xl mx-auto text-white ">
          <div className="absolute w-fit  inset-x-0 bottom-0">
            <h4 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center  text-white leading-snug drop-shadow-lg">
              SMART Engineering
            </h4>

            <p class="text-2xl mb-16 mt-10 font-light text-center justify-center drop-shadow-lg">
              At Anthem, we have a straightforward goal – to design, engineer
              and manufacture audio/video products that deliver exceptional
              performance and convenience at a reasonable price. We do this by
              spending thousands of hours selecting and testing components,
              carefully designing our own circuit topologies, and backing them
              with robust power supplies that ensure maximum long-term quality
              and reliability.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SmartEngineering;
